const elyosCharTable = [
	{
		char: [
			'',
			'i',
			'h',
			'k',
			'j',
			'm',
			'l',
			'o',
			'n',
			'q',
			'p',
			's',
			'r',
			'u',
			't',
			'w',
			'v',
			'y',
			'x',
			'a',
			'z',
			'c',
			'b',
			'e',
			'd',
			'g',
			'f',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			2,
			1,
			2,
			2,
			2,
			2,
			2,
			2,
		],
	},
	{
		char: [
			'',
			'd',
			'c',
			'f',
			'e',
			'h',
			'g',
			'j',
			'i',
			'l',
			'k',
			'n',
			'm',
			'p',
			'o',
			'r',
			'q',
			't',
			's',
			'v',
			'u',
			'x',
			'w',
			'z',
			'y',
			'b',
			'a',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			2,
			2,
		],
	},
	{
		char: [
			'',
			'e',
			'd',
			'g',
			'f',
			'i',
			'h',
			'k',
			'j',
			'm',
			'l',
			'o',
			'n',
			'q',
			'p',
			's',
			'r',
			'u',
			't',
			'w',
			'v',
			'y',
			'x',
			'a',
			'z',
			'c',
			'b',
		],
		next: [
			0,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			1,
			2,
			1,
			2,
			2,
		],
	},
]

export default elyosCharTable
